import axios, { type AxiosInstance, type AxiosRequestConfig, type InternalAxiosRequestConfig } from 'axios';

import { errorResponseStatusHandler } from '@/utils/responseStatusHandler';

import { getAuthenticatedUser } from './oidc';

async function requestInterceptor<T>(config: InternalAxiosRequestConfig<T>) {
  const user = await getAuthenticatedUser();
  if (!user) return config;
  config.headers['Authorization'] = `${user.token_type} ${user.access_token}`;
  return config;
}

async function onFulfilled<T>(response: T) {
  return response;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- axios error type
async function onRejected(error: any) {
  if (error.response) {
    const request = error.config;
    const { response } = error;

    if (response.status === 401 && !request._retry) {
      request._retry = true;
      const user = await getAuthenticatedUser();
      if (user == null) {
        return Promise.reject(error); // NOSONAR -- we want to reject the promise
      }
    }
    errorResponseStatusHandler(response);
  }
  return Promise.reject(error); // NOSONAR -- we want to reject the promise
}

export function createApiInstance(config?: AxiosRequestConfig | undefined): AxiosInstance {
  const instance = axios.create(config);
  instance.interceptors.request.use(requestInterceptor);
  instance.interceptors.response.use(onFulfilled, onRejected);
  return instance;
}
